/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findUnitTokens} from '../api'

export const useMutationFindUnitTokens = createReactQueryMutationHook('findUnitTokens', findUnitTokens)
